 (function() {
    const originalTitle = document.title;
    const alertTitle = "Hey cittadin* Extralandia! Torna qui!";
    let intervalId = null;

    function startSwap() {
      if (intervalId) return;
      let showAlert = false;
      intervalId = setInterval(() => {
        document.title = showAlert ? alertTitle : originalTitle;
        showAlert = !showAlert;
      }, 5000);
    }

    function stopSwap() {
      if (!intervalId) return;
      clearInterval(intervalId);
      intervalId = null;
      document.title = originalTitle; 
    }

    
    document.addEventListener("visibilitychange", () => {
      if (document.hidden) startSwap();
      else stopSwap();
    });
  })();